import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ArrowLeftIcon } from 'lucide-react';
import { type Role, type QuestionData } from '../data/surveyData';
import { BarChart } from './BarChart';
import { RoleToggle } from './RoleToggle';
interface FeedbackSlideProps {
  questionData: QuestionData;
  currentRole: Role;
  userAnswerId: string;
  onContinue: () => void;
  onBack: () => void;
  onRoleChange: (role: Role) => void;
  isLast: boolean;
}
export function FeedbackSlide({
  questionData,
  currentRole,
  userAnswerId,
  onContinue,
  onBack,
  onRoleChange,
  isLast
}: FeedbackSlideProps) {
  return <div className="flex-1 flex items-center justify-center px-5 py-8" data-id="element-52">
      <motion.div className="w-full max-w-sm" initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.35,
      ease: 'easeOut'
    }} data-id="element-53">
        {/* Back button */}
        <button onClick={onBack} className="flex items-center gap-1 text-xs font-semibold text-clinical-muted active:text-clinical-text transition-colors mb-3" data-id="element-54">
          <ArrowLeftIcon className="w-3.5 h-3.5" data-id="element-55" />
          Back to question
        </button>

        <div className="bg-white border-2 border-gray-100 rounded-2xl p-5 shadow-sm" data-id="element-56">
          <div className="mb-5" data-id="element-57">
            <h2 className="text-lg font-bold text-clinical-text mb-1.5" data-id="element-58">
              {questionData.feedbackHeadline}
            </h2>
            <p className="text-clinical-secondary text-xs leading-relaxed" data-id="element-59">
              {questionData.feedbackBody}
            </p>
          </div>

          <BarChart options={questionData.options} currentRole={currentRole} userAnswerId={userAnswerId} data-id="element-60" />

          <div className="mt-5 pt-4 border-t border-gray-100" data-id="element-61">
            <RoleToggle currentRole={currentRole} onRoleChange={onRoleChange} compact data-id="element-62" />
          </div>
        </div>

        <motion.button initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} whileTap={{
        scale: 0.97
      }} onClick={onContinue} className="mt-4 w-full inline-flex items-center justify-center gap-2 bg-era-red active:bg-era-red-dark text-white font-bold px-5 py-3.5 rounded-2xl transition-colors duration-150 text-sm" data-id="element-63">
          {isLast ? 'See insights' : 'Next question'}
          <ArrowRightIcon className="w-4 h-4" data-id="element-64" />
        </motion.button>
      </motion.div>
    </div>;
}